export const AGREEMENT_TYPE_TOU = 1
export const AGREEMENT_TYPE_PRIVACY = 2
export const AGREEMENT_TYPE_GAME = 3
export const AGREEMENT_TYPE_API = 4
export const AGREEMENT_TYPE_MONETIZATION = 5
export const AGREEMENT_TYPE_AUP = 6
export const AGREEMENT_TYPE_COOKIES = 7
export const AGREEMENT_TYPE_REFUND = 8

export const MEMBER_LEVEL_GUEST = 0
export const MEMBER_LEVEL_MEMBER = 1
export const MEMBER_LEVEL_CONTRIBUTOR = 2
export const MEMBER_LEVEL_MANAGER = 4
export const MEMBER_LEVEL_LEADER = 8

export const TEAM_MEMBER_LEVEL_MODERATOR = 1
export const TEAM_MEMBER_LEVEL_MANAGER = 4
export const TEAM_MEMBER_LEVEL_ADMINISTRATOR = 8

export const USER_PRIVACY_EVERYONE = 0
export const USER_PRIVACY_FOLLOWERS = 1
export const USER_PRIVACY_NONE = 2
export const USER_SHOW_ONLINE_STATUS = 4
export const MESSAGE_FROM_VERIFIED_ONLY = 8
export const MESSAGE_FROM_FOLLOWING_ONLY = 16
export const MESSAGE_FROM_NO_ONE = 32
export const COMMENT_HISTORY_HIDDEN = 64

export const STATUS_NOT_ACCEPTED = 0
export const STATUS_ACCEPTED = 1
export const STATUS_DELETED = 3
export const STATUS_BANNED = 4

export const VISIBLE_HIDDEN = 0
export const VISIBLE_PUBLIC = 1

export const VISIBILITY_OPTIONS = [
  { text: 'public', value: VISIBLE_PUBLIC },
  { text: 'private', value: VISIBLE_HIDDEN },
]

export const PAGINATION_DEFAULT_PAGE = 1
export const PAGINATION_DEFAULT_TOTAL = 0
export const PAGINATION_DEFAULT_LIMIT = 30

export const MIN_AGE_DEFAULT = 13

export const RATINGS_LIKE = 1
export const RATINGS_DISLIKE = -1
export const RATINGS_UNDECIDED = 0
export const RATINGS_FEW = 5
export const RATINGS_MANY = 50

export const CURATION_NONE = 0
export const CURATION_PAID = 1
export const CURATION_FULL = 2
export const CURATION_COLLECTIONS = 4
export const CURATION_MODS = 8

export const API_THIRD_PARTY_ACCESS = 1
export const API_DIRECT_DOWNLOAD = 2
export const API_AUTHORISED_DOWNLOADS = 4
export const API_PAID_DOWNLOADS = 8

export const GAME_MOD_SUBMISSION_TOOLS_ONLY = 0
export const GAME_MOD_SUBMISSION_TOOLS_AND_WEBSITE = 1

export const GAME_COMMUNITY_ALLOW_MOD_COMMENTS = 1
export const GAME_COMMUNITY_ALLOW_NEGATIVE_RATINGS = 256
export const GAME_COMMUNITY_ALLOW_EDITS_VIA_WEB = 512
export const GAME_COMMUNITY_ALLOW_GUIDE_COMMENTS = 2048
export const GAME_COMMUNITY_ALLOW_UGC_PERMISSIONS = 4096
export const GAME_COMMUNITY_ALLOW_COLLECTIONS = 8192
export const GAME_COMMUNITY_ALLOW_COLLECTION_COMMENTS = 16384
export const GAME_COMMUNITY_ALLOW_MOD_COMMENTS_TO_BE_DOWNVOTED = 32768
export const GAME_COMMUNITY_ALLOW_GUIDE_COMMENTS_TO_BE_DOWNVOTED = 65536
export const GAME_COMMUNITY_ALLOW_MOD_PREVIEW = 262144

export const MOD_COMMUNITY_ALLOW_DEPENDENCY = 1024
export const MOD_COMMUNITY_ALLOW_MOD_USE_IN_COLLECTIONS = 131072

export const GAME_DISALLOW_DEPENDENCIES = 0
export const GAME_ALLOW_DEPENDENCIES_OPT_IN = 1
export const GAME_ALLOW_DEPENDENCIES_OPT_OUT = 2
export const GAME_ALLOW_DEPENDENCIES = 3

export const MOD_COMMUNITY_ALLOW_COMMENTS = 1
export const GUIDE_COMMUNITY_ALLOW_COMMENTS = 2048

export const COMMENT_PINNED = 1
export const COMMENT_LOCKED = 2
export const COMMENT_SCRUBBED = 4

export const SHOW_CREDITS = 1
export const ORIGINAL_OR_PERMITTED_ASSETS = 2
export const ALLOW_REDISTRIBUTION = 4
export const ALLOW_PORTING = 8
export const ALLOW_PATCHING_NO_CREDIT = 16
export const ALLOW_PATCHING_WITH_CREDIT = 32
export const ALLOW_PATCHING_WITH_PERMISSION = 64
export const ALLOW_REPACKAGE_NO_CREDIT = 128
export const ALLOW_REPACKAGE_WITH_CREDIT = 256
export const ALLOW_REPACKAGE_WITH_PERMISSION = 512
export const ALLOW_USERS_TO_RESELL = 1024

export const AGREEMENT_TYPE_OPTIONS = [
  {
    value: AGREEMENT_TYPE_TOU,
    short: 'Terms',
    paths: ['terms'],
  },
  {
    value: AGREEMENT_TYPE_AUP,
    short: 'AUP',
    paths: ['aup'],
  },
  {
    value: AGREEMENT_TYPE_PRIVACY,
    short: 'Privacy',
    paths: ['privacy'],
  },
  {
    value: AGREEMENT_TYPE_MONETIZATION,
    short: 'Monetization',
    paths: ['monetization'],
  },
  {
    value: AGREEMENT_TYPE_API,
    short: 'API',
    paths: ['apiterms'],
  },
  {
    value: AGREEMENT_TYPE_GAME,
    short: 'Game',
    paths: ['gameterms'],
  },
  {
    value: AGREEMENT_TYPE_REFUND,
    short: 'Refund',
    paths: ['refund'],
  },
]

export const TEAM_MEMBER_LEVELS_OPTIONS = [
  { value: TEAM_MEMBER_LEVEL_ADMINISTRATOR, text: 'admin' },
  { value: TEAM_MEMBER_LEVEL_MANAGER, text: 'manager' },
  { value: TEAM_MEMBER_LEVEL_MODERATOR, text: 'moderator' },
]

export const REPORT_TYPE_DMCA = 1
export const REPORT_TYPE_NOT_WORKING = 2

export const REPORT_TYPE_OPTIONS = [
  // API 0=generic, however it should not be a selectable option on report
  { value: 0, text: '' },
  { value: REPORT_TYPE_DMCA, text: 'report_dmca' },
  { value: REPORT_TYPE_NOT_WORKING, text: 'report_not_working' },
  { value: 3, text: 'report_rude_content' },
  { value: 4, text: 'report_illegal_content' },
  { value: 5, text: 'report_stolen_content' },
  { value: 6, text: 'report_false_information' },
  { value: 7, text: 'report_other' },
]

export const REPORT_TYPE_OPTIONS_COLLECTIONS = [
  // API 0=generic, however it should not be a selectable option on report
  { value: 0, text: '' },
  { value: REPORT_TYPE_NOT_WORKING, text: 'report_not_working' },
  { value: 3, text: 'report_rude_content' },
  { value: 5, text: 'report_stolen_content' },
]

export const REPORT_NOT_WORKING_REASONS = [
  { value: 0, text: '' },
  { value: 1, text: 'report_crash' },
  { value: 2, text: 'report_no_load' },
  { value: 3, text: 'report_conflicts' },
  { value: 4, text: 'report_missing_deps' },
  { value: 5, text: 'report_install_issues' },
  { value: 6, text: 'report_bugs' },
  { value: 7, text: 'report_incompatability' },
  { value: 8, text: 'report_corrupt' },
]

// These values are consistent with the API
export const RESOURCE_GAMES = 'games'
export const RESOURCE_MODS = 'mods'
export const RESOURCE_GUIDES = 'articles'
export const RESOURCE_USERS = 'users'
export const RESOURCE_COLLECTIONS = 'collections'

export const RESOURCE_OPTIONS = {
  [RESOURCE_GAMES]: 'Game',
  [RESOURCE_MODS]: 'Mod',
  [RESOURCE_GUIDES]: 'Guide',
  [RESOURCE_USERS]: 'User',
  [RESOURCE_COLLECTIONS]: 'Collection',
}

export const MATURITY_NONE = 0
export const MATURITY_ALCOHOL = 1
export const MATURITY_DRUGS = 2
export const MATURITY_VIOLENCE = 4
export const MATURITY_EXPLICIT = 8

export const MOD_MATURITY_OPTIONS = [
  { value: MATURITY_ALCOHOL, text: 'mature_content_alcohol' },
  { value: MATURITY_DRUGS, text: 'mature_content_drugs' },
  { value: MATURITY_VIOLENCE, text: 'mature_content_violence' },
  { value: MATURITY_EXPLICIT, text: 'mature_content_explicit' },
]

export const GAME_MATURE_MODS_DENY = 0
export const GAME_MATURE_MODS_ALLOW = 1
export const GAME_ADULTS_ONLY = 2

export const DISCUSSION_TYPE_MODS = 'mods'
export const DISCUSSION_TYPE_GUIDES = 'guides'
export const DISCUSSION_TYPE_COLLECTIONS = 'collections'
export const DISCUSSION_TYPES = [
  DISCUSSION_TYPE_MODS,
  DISCUSSION_TYPE_GUIDES,
  DISCUSSION_TYPE_COLLECTIONS,
]

export const RATINGS_TEXT_OPTIONS = {
  UNRATED: 'unrated',
  OVERWHELMINGLY_POSITIVE: 'overwhelmingly_positive',
  VERY_POSITIVE: 'very_positive',
  POSITIVE: 'positive',
  MOSTLY_POSITIVE: 'mostly_positive',
  MIXED: 'mixed',
  MOSTLY_NEGATIVE: 'mostly_negative',
  NEGATIVE: 'negative',
  VERY_NEGATIVE: 'very_negative',
  OVERWHELMINGLY_NEGATIVE: 'overwhelmingly_negative',
}

export const PLATFORM_SOURCE = 'source'
export const PLATFORM_WINDOWS = 'windows'
export const PLATFORM_MAC = 'mac'
export const PLATFORM_LINUX = 'linux'
export const PLATFORM_ANDROID = 'android'
export const PLATFORM_IOS = 'ios'
export const PLATFORM_XBOXONE = 'xboxone'
export const PLATFORM_XBOXSERIESX = 'xboxseriesx'
export const PLATFORM_PS4 = 'ps4'
export const PLATFORM_PS5 = 'ps5'
export const PLATFORM_SWITCH = 'switch'
export const PLATFORM_SWITCH2 = 'switch2'
export const PLATFORM_OCULUS = 'oculus'
export const PLATFORM_WINDOWSSERVER = 'windowsserver'
export const PLATFORM_LINUXSERVER = 'linuxserver'

export const GAME_PLATFORMS = [
  PLATFORM_SOURCE,
  PLATFORM_WINDOWS,
  PLATFORM_WINDOWSSERVER,
  PLATFORM_MAC,
  PLATFORM_LINUX,
  PLATFORM_LINUXSERVER,
  PLATFORM_ANDROID,
  PLATFORM_IOS,
  PLATFORM_OCULUS,
  PLATFORM_XBOXONE,
  PLATFORM_XBOXSERIESX,
  PLATFORM_PS4,
  PLATFORM_PS5,
  PLATFORM_SWITCH,
  PLATFORM_SWITCH2,
]

export const GAME_PLATFORM_LABELS = {
  [PLATFORM_SOURCE]: 'Source',
  [PLATFORM_WINDOWS]: 'Windows',
  [PLATFORM_WINDOWSSERVER]: 'Windows Server',
  [PLATFORM_MAC]: 'Mac',
  [PLATFORM_LINUX]: 'Linux',
  [PLATFORM_LINUXSERVER]: 'Linux Server',
  [PLATFORM_ANDROID]: 'Android',
  [PLATFORM_IOS]: 'iOS',
  [PLATFORM_XBOXONE]: 'Xbox One',
  [PLATFORM_XBOXSERIESX]: 'Xbox Series X/S',
  [PLATFORM_PS4]: 'PlayStation 4',
  [PLATFORM_PS5]: 'PlayStation 5',
  [PLATFORM_SWITCH]: 'Nintendo Switch',
  [PLATFORM_SWITCH2]: 'Nintendo Switch 2',
  [PLATFORM_OCULUS]: 'Oculus',
}

export const SHORT_GAME_PLATFORM_LABELS = {
  ...GAME_PLATFORM_LABELS,
  [PLATFORM_WINDOWS]: 'Win',
  [PLATFORM_WINDOWSSERVER]: 'Win Server',
  [PLATFORM_XBOXONE]: 'XB1',
  [PLATFORM_XBOXSERIESX]: 'XSX',
  [PLATFORM_PS4]: 'PS4',
  [PLATFORM_PS5]: 'PS5',
  [PLATFORM_SWITCH]: 'Switch',
  [PLATFORM_SWITCH2]: 'Switch 2',
}

export const PLATFORM_ICONS = {
  [PLATFORM_WINDOWS]: 'windows_logo',
  [PLATFORM_WINDOWSSERVER]: 'windows_logo',
  [PLATFORM_PS4]: 'playstation_logo',
  [PLATFORM_PS5]: 'playstation_logo',
  [PLATFORM_XBOXONE]: 'xbox_logo',
  [PLATFORM_XBOXSERIESX]: 'xbox_logo',
  [PLATFORM_SWITCH]: 'switch_logo',
  [PLATFORM_SWITCH2]: 'switch_2_logo',
  [PLATFORM_OCULUS]: 'oculus_logo',
  [PLATFORM_IOS]: 'apple_logo',
  [PLATFORM_MAC]: 'apple_logo',
  [PLATFORM_ANDROID]: 'android_logo',
  [PLATFORM_SOURCE]: 'steam_logo',
  [PLATFORM_LINUX]: 'linux_logo',
  [PLATFORM_LINUXSERVER]: 'linux_logo',
}

export const PLATFORM_FILTERS_TO_HIDE = [PLATFORM_SOURCE]

export const PLATFORM_STATUS_PENDING = 0
export const PLATFORM_STATUS_APPROVED = 1
export const PLATFORM_STATUS_DENIED = 2
export const PLATFORM_STATUS_TARGETED = 3

export const FILE_VIRUS_SCAN_NOT_STARTED = 0
export const FILE_VIRUS_SCAN_COMPLETE = 1
export const FILE_VIRUS_SCAN_IN_PROGRESS = 2
export const FILE_VIRUS_SCAN_ERROR_FILE_TOO_LARGE = 3
export const FILE_VIRUS_SCAN_ERROR_FILE_NOT_FOUND = 4
export const FILE_VIRUS_SCAN_ERROR_SCANNING = 5

export const FILE_VIRUS_NONE = 0
export const FILE_VIRUS_FOUND = 1
export const FILE_VIRUS_RISK = 2

export const ITEM_TYPES = {
  COLLECTION: 'collection',
  MOD: 'mod',
  GUIDE: 'guide',
  GAME: 'game',
}

export const BROWSE_TABS = {
  MODS: 'mods',
  FEATURED: 'featured',
  TOKEN_PACKS: 'token_packs',
  COLLECTIONS: 'collections',
  GUIDES: 'guides',
  CONTENT: 'content',
  LIBRARY: 'library',
}

export const MODAL_MARGIN = 96

export const PURCHASE_STEPS = {
  CHECKOUT: 'checkout',
  RECEIPT: 'receipt',
  CART: 'cart',
}
